/**
 * Dev-Only Overrides
 * ==================
 * 
 * These flags are for local development and testing ONLY.
 * They allow developers to bypass authentication and subscription checks
 * to verify UI components and flows without needing specific user states.
 * 
 * ⚠️ CRITICAL WARNING:
 * 1. These must ALL be false in production.
 * 2. Do not commit this file with any of these set to true.
 * 3. These overrides only affect the frontend client state. They do NOT
 *    bypass backend security rules (Firestore/Storage rules still apply).
 * 
 * PRODUCTION SAFETY: All overrides are explicitly disabled regardless of environment variables.
 * For local development testing, temporarily change these values, but NEVER commit them as true.
 */

// PRODUCTION SAFETY: Explicitly disabled - do not rely on environment variables
const FORCE_SURFACES = false;

// Force the app to treat the current user as having the "isPro" claim
// PRODUCTION: DISABLED
export const FORCE_PRO_MODE = false;

// Force the app to treat the current user as having an active subscription
// PRODUCTION: DISABLED
export const FORCE_ACTIVE_SUBSCRIPTION = false;

// Force the app to treat the current user as an Admin (Super/Support)
// PRODUCTION: DISABLED
export const FORCE_ADMIN_MODE = false;
